import { AML_STATUS_QUERY, GRACE_PERIOD_QUERY, ACCOUNT_IS_PROCESSING_STATUS_QUERY, USER_LOGGED_IN_UPDATED, UPDATE_AML_STATUS, AML_STATUS_UPDATED, GRACE_PERIOD_UPDATED, ACCOUNT_PEP_BLOCK_QUERY } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { AmlStatus } from '@gig/magic-sdk/dist/adapter/users/getAmlStatus';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const CHECK_INTERVAL_MINUTES = 8 * 60 * 1e3;
class AmlService {
  constructor() {
    this.isLoggedIn = false;
    this.amlStatus = null;
    this.amlTimerInterval = CHECK_INTERVAL_MINUTES;
    this.intervalID = null;
    this.amlQuerySubscription = null;
    this.gracePeriodSubscription = null;
    this.gracePeriod = [];
    this.subscriptions = [];
    this.loading = false;
    this.userBlocksSubscription = null;
    this.isProcessing = false;
    this.amlHandler = () => __async(this, null, function* () {
      if (this.loading) {
        return;
      }
      this.unsubscribeQueries();
      try {
        this.loading = true;
        yield Promise.all([
          this.updateAmlStatus(),
          this.updateGracePeriod()
        ]);
        this.setIsProcessing();
      } catch (e) {
        console.log("unable to update aml status", e);
      } finally {
        this.loading = false;
        this.registerQueryHandlers();
      }
    });
    this.registerEvents();
    this.subscribeToUserLoginChanges();
    this.subscribeUpdateAmlCommand();
  }
  registerQueryHandlers() {
    this.amlQuerySubscription = window.queryBus.subscribe(AML_STATUS_QUERY, () => {
      return this.amlStatus;
    });
    this.gracePeriodSubscription = window.queryBus.subscribe(GRACE_PERIOD_QUERY, () => {
      return this.gracePeriod;
    });
    this.userBlocksSubscription = window.queryBus.subscribe(ACCOUNT_IS_PROCESSING_STATUS_QUERY, () => {
      return this.isLoggedIn && this.isProcessing;
    });
  }
  unsubscribeQueries() {
    var _a, _b, _c;
    (_a = this.amlQuerySubscription) == null ? void 0 : _a.unsubscribe();
    (_b = this.gracePeriodSubscription) == null ? void 0 : _b.unsubscribe();
    (_c = this.userBlocksSubscription) == null ? void 0 : _c.unsubscribe();
    this.amlQuerySubscription = null;
    this.gracePeriodSubscription = null;
    this.userBlocksSubscription = null;
  }
  subscribeToUserLoginChanges() {
    window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, (e) => __async(this, null, function* () {
      this.isLoggedIn = !!e.payload;
      yield this.amlHandler();
      if (this.isLoggedIn && !this.intervalID) {
        this.setAmlGetterInterval();
        this.subscribeToMagicEvents();
      } else {
        this.clearAmlInterval();
        this.clearMagicSubscriptions();
      }
    }), { replay: true });
  }
  subscribeToMagicEvents() {
    this.subscriptions.push(magic.events.firstDeposit(this.amlHandler).unsub, magic.events.subsequentDeposit(this.amlHandler).unsub, magic.events.KYCStatusUpdated(this.amlHandler).unsub, magic.events.withdrawStatusChanged(this.amlHandler).unsub, magic.events.userBlockStatusChanged(this.amlHandler).unsub);
  }
  clearMagicSubscriptions() {
    this.subscriptions.forEach((unsub) => unsub());
    this.subscriptions = [];
  }
  subscribeUpdateAmlCommand() {
    window.commandBus.subscribe(UPDATE_AML_STATUS, () => __async(this, null, function* () {
      yield this.amlHandler();
    }));
  }
  setIsProcessing() {
    this.isProcessing = false;
    if (!this.amlStatus) {
      return;
    }
    const { status } = this.amlStatus;
    const processing = AmlStatus.PROCESSING;
    const disallowed = [
      AmlStatus.PENDING,
      AmlStatus.PENDING_REQUEST,
      AmlStatus.REQUESTED,
      AmlStatus.USER_REQUESTED,
      processing,
      AmlStatus.REJECTED
    ];
    if (disallowed.includes(status.photoID) || disallowed.includes(status.address)) {
      this.isProcessing = status.photoID === processing || status.address === processing;
    }
  }
  registerEvents() {
    window.queryBus.register(AML_STATUS_QUERY, {
      type: "object"
    });
    window.queryBus.register(GRACE_PERIOD_QUERY, {
      type: "array"
    });
    window.eventBus.register(AML_STATUS_UPDATED, {
      type: ["object", "null"]
    });
    window.eventBus.register(GRACE_PERIOD_UPDATED, {
      type: "array"
    });
  }
  updateAmlStatus() {
    return __async(this, null, function* () {
      if (!this.isLoggedIn) {
        this.amlStatus = null;
        window.eventBus.publish(AML_STATUS_UPDATED, this.amlStatus);
        return;
      }
      const isPepBlocked = yield window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY);
      if (isPepBlocked) {
        return;
      }
      try {
        this.amlStatus = yield magic.methods.users.getAmlStatus();
      } catch (e) {
        console.error("aml status fetch failed");
      }
      window.eventBus.publish(AML_STATUS_UPDATED, this.amlStatus);
    });
  }
  updateGracePeriod() {
    return __async(this, null, function* () {
      if (!this.isLoggedIn) {
        this.gracePeriod = [];
        window.eventBus.publish(GRACE_PERIOD_UPDATED, this.gracePeriod);
        return;
      }
      try {
        this.gracePeriod = yield magic.methods.users.getGracePeriods();
      } catch (e) {
        console.error("grace period fetch failed");
      }
      window.eventBus.publish(GRACE_PERIOD_UPDATED, this.gracePeriod);
    });
  }
  setAmlGetterInterval() {
    this.clearAmlInterval();
    this.intervalID = setInterval(() => __async(this, null, function* () {
      return yield this.amlHandler();
    }), this.amlTimerInterval);
  }
  clearAmlInterval() {
    if (!!this.intervalID) {
      clearInterval(this.intervalID);
    }
    this.intervalID = null;
  }
}

export { AmlService };
